import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * Minimal package upload store state
 * Only contains truly global state that needs persistence across components
 *
 * Reduced from 415 lines to ~40 lines by moving:
 * - Upload state → React Query
 * - Form state → Local component state
 * - Progress tracking → Local component state
 * - Validation → Computed local state
 */
export interface PackageUploadState {
  // User context (should come from auth in the future)
  customerId: string | null;
  uploadProgress: number;

  // Actions
  setCustomerId: (customerId: string | null) => void;
  setUploadProgress: (progress: number) => void;
  reset: () => void;
}

/**
 * Initial state
 */
const initialState = {
  customerId: null,
  uploadProgress: 0,
};

/**
 * Simplified package upload store using Zustand
 * Reduced from 415 lines to ~40 lines by moving state to React Query and local component state
 */
export const usePackageUploadStore = create<PackageUploadState>()(
  devtools(
    (set) => ({
      ...initialState,

      setCustomerId: (customerId) => {
        set({ customerId });
      },

      setUploadProgress: (progress) => {
        set({ uploadProgress: progress });
      },

      reset: () => {
        set(initialState);
      },
    }),
    {
      name: "package-upload-store",
      version: 2, // Incremented version due to breaking changes
    }
  )
);
